import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setStage } from 'slices/drawer'
import { setInternetInfo } from 'slices/contract'
import { wifiService } from 'services'
import {
  ModemInfo,
  ModemEdit,
  ModemSuccess,
  ModemInProgress,
  ModemError,
  ModemErrorServer,
  Clerk,
} from './components'
import { STAGES } from './constants'

export function ModemDrawer() {
  const { stage } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()
  const {
    internet,
    selected: { id: idContract },
  } = useSelector(({ contract }) => contract)
  const { getInternet } = wifiService()

  useEffect(() => {
    async function fetchInternet() {
      try {
        const { data } = await getInternet(idContract)
        const canChangeWifi = data?.canBeChanged

        dispatch(setInternetInfo(data))
        if (!canChangeWifi) dispatch(setStage(STAGES.CLERK))
      } catch (error) {
        dispatch(setStage(STAGES.ERROR_SERVER))
      }
    }

    if (!internet) fetchInternet()
  }, [dispatch, idContract, internet])

  return stages()[stage]
}

function stages() {
  return {
    [STAGES.INITIAL]: <ModemInfo />,
    [STAGES.EDIT]: <ModemEdit />,
    [STAGES.SUCCESS]: <ModemSuccess />,
    [STAGES.IN_PROGRESS]: <ModemInProgress />,
    [STAGES.ERROR]: <ModemError />,
    [STAGES.ERROR_SERVER]: <ModemErrorServer />,
    [STAGES.CLERK]: <Clerk />,
  }
}
